import React from 'react';
import { Textarea } from "@headlessui/react";

interface Props {
    label: string;
    placeholder?: string;
    type?: string;
    value: string;
    setValue: (value: string) => void;
    numberOfLines?: number;
}

function TextArea(props: Props) {
    return (
        <div className="text-field">
            <div className="label">{props.label}</div>
            <Textarea
                className="text-area"
                value={props.value}
                rows={props.numberOfLines || 3}
                placeholder={props.placeholder || 'Enter value'}
                onChange={(e) => props.setValue(e.target.value)}
            />
        </div>
    );
}

export default TextArea;
